import { number, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { registerFormatter } from '@philips-emr/tws-core/lib/services/model-service';

import { createNumericFormatter } from '../generators';

export const FLOAT = 'float';

const FloatFormatter = createNumericFormatter({
  defaultOptions: {
    padFractionalZeros: true,
    scale: 2,
  },
  formatterOptionTypes: {
    radix: string,
    scale: number.placeholder(2),
    thousandsSeparator: string,
  },
  invalidMessage: 'tws.formatter.float.invalid',
  name: FLOAT,
});

export default registerFormatter(FLOAT, FloatFormatter);
